import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpParams } from '@angular/common/http';




@Component({
  selector: 'page-addons-version-pro-cancel',
  templateUrl: 'addons-version-pro-cancel.html',
})
export class AddonsVersionProCancelPage {

  addon_cancel: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    public http: HttpClient) {

  }

  close() {
    this.globals.side_menu_config_active = '';
    this.navCtrl.pop();
  }

  async cancelSuscriptionAsk() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('addons-seguro-cancelar'),
      message: this.translate.instant('addons-perder-todas-ventajas-pro') + this.globals.restaurant.license.toUpperCase(),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.cancelSuscriptionOk();
          }
        }
      ]
    });
    alert.present();

  }

  async cancelSuscriptionOk() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();

    //Cancelamos suscribcion
    const params_cancel = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('reason', '');
    await this.http.post(this.globals.analytics_path + 'stripe/mct_suscription_cancel', params_cancel, {})
      .subscribe(async res => {

      });
    loadingPopup.dismiss();
    window.location.reload();
  }

  openUpdateVersion() {
    if (this.globals.so_mobile) {
      window.location.assign('https://mycheftool.com/tarifas');
    } else {
      window.open('https://mycheftool.com/tarifas', '_blank');
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/addons/addons-version-pro-cancel/addons-version-pro-cancel.ts